import { Wording } from '@/types';

export const ASTROLOGY_WORDING_RS: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditacije',
  components_header_media_2: 'Podkast',
  components_header_text1: 'Vodiči',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Istražite zvezde u sebi',
  hero_button_text: 'Počnite ovde',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi alati koji su vam potrebni za kosmički uvid i samootkrivanje',
  components_ressources_span_text: 'Proširite svoj unutrašnji univerzum kuriranom mešavinom podkasta i članaka. Bez obzira da li tražite kosmički uvid, jasnoću ili duhovno poravnanje, naši resursi vam pomažu da se povežete sa astrologijom na praktičan, smislen način.',
  components_ressources_card_1_title: 'Duboke teme',
  components_ressources_card_1_text: 'Uronite u bogatu kolekciju detaljnih podcasta koji pokrivaju astrologiju, tarot, kosmičke arhetipove i duhovni rast — dizajniranih da prošire vašu svest i prodube vašu praksu.',
  components_ressources_card_2_title: 'Zvezdani uvidi',
  components_ressources_card_2_text: 'Astrološki saveti i postovi na blogu za samosvest i duševni rast.',
  components_ressources_link: 'Istražite dalje',
  components_notes_and_google_title_1: 'Astrološki uvidi',
  components_notes_and_google_title_2: 'Kosmička rutina',
  components_notes_and_google_title_3: 'Refleksije',
  components_review_google_text: 'Google recenzije',
  media_content_section_title: 'AUDIO',
  media_content_section_subheader_text: 'Naš podkast',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više epizoda',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članci',
  text2_section_button_more: 'Učitaj više',
  components_text1_section_title: 'VODIČI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: 'Prikaži sve vodiče',
  components_footer_text: 'Probudite svoj unutrašnji kosmos: vaš put, vaše zvezde.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registracioni broj',
  components_footer_legal: 'Pravni odeljak',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj još',
  page_media_1_content_hero_text: 'Podcast epizode',
  page_media_content_menu_foundations: 'Osnove',
  page_media_content_menu_spirituality: 'Duhovnost',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologija',
  page_media_content_menu_trends: 'Trendovi',
  page_media_2_content_hero_text: 'Media 2',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci',
  enter_email_title: 'Unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava je uspela!',
  components_card_link_media_content: 'Slušaj sada',
  components_card_link_text1_content: 'Vidi vodič',
  components_card_link_text2_content: 'Vidi članak',
  france: 'Francuska',
  cyprus: 'Kipar',
  tag_podcast: 'Подкаст',
  tag_meditation: 'Медитација',
  page_media_content_menu_all: 'Sve',
};